export default __webpack_public_path__ + "static/media/copyActive.b65bf141.svg";